import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { IconNotifications } from '@bynder/icons';
import { initLegacyNotifications } from '../../legacy/legacy';

/*
 * bynder-platform/bynder/views/navigation/topmenu.cfm: 118
 */
export function NotificationCenter() {
	useEffect(() => {
		try {
			initLegacyNotifications();
		} catch (error) {
			console.error(error);
			Sentry.captureException(error);
		}
	}, []);

	return (
		<li className="notifications-nav">
			<a
				href="#"
				className="admin-dropdown"
				data-toggle="dropdown"
				role="button"
				aria-expanded="false"
			>
				<IconNotifications />
				<span className="badge">0</span>
			</a>
		</li>
	);
}
